import { Block } from '@comp/crRender'
import { useTranslation } from 'react-i18next'
import useEditProfile from './hooks/useEditProfile'
import ActionBtn from '../../../../components/ActionBtn'
import { BasicInformation, ContactInformation, Accreditations, Specialties, AdvancedTechs, RefundPolicy, GalleryImgs, ProviderDocs, PaymentTerms, Scalations } from './sections'
import './style.css'
import { useMemo } from 'react'

const EditProfile = ({ cancelAction, providerInfo, isPending }) => {
    const { t } = useTranslation()
    const { formHandler, handleSave, isLoading, isUpdating } = useEditProfile(providerInfo)


    const isDisabled = useMemo(() => isLoading || isUpdating, [isLoading, isUpdating])

    return (
        <Block isRender={true} className="hospital-profile-container edit-mode mx-2 row">
            {/* Header with Actions */}
            <div className="provider-profile-header hospital-profile-header">
                <h3 className="hospital-profile-title">{t("edit-hospital-portfolio")}</h3>
                <div className="header-actions">
                    {cancelAction}
                    <ActionBtn title={isDisabled ? "saving..." : "save-changes"} onApply={handleSave} isDisabled={isDisabled} className="btn-primary" />
                </div>
            </div>

            <BasicInformation isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />

            <ProviderDocs isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />

            <ContactInformation isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />
            <Scalations isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />
            <Specialties isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />

            <Accreditations isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />

            <AdvancedTechs isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />

            <GalleryImgs isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />
            <PaymentTerms isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />

            {/* 
            <RefundPolicy isLoading={isPending} formHandler={formHandler} providerInfo={providerInfo} />
 */}
        </Block>
    )
}

export default EditProfile

